<h2>Ostatnie zmiany w Zalamo</h2>
@if (details.publicSessions) {
  <h3>
    <mat-icon svgIcon="s_public_session"></mat-icon>
    Sesje publiczne
  </h3>
  @if (details.publicSessions.fix) {
    <div>
      <h4>
        <mat-icon>thumb_up</mat-icon>
        Poprawki
      </h4>
      <ol>
        @for (fix of details.publicSessions.fix; track fix) {
          <li>
            {{ fix.label }}
            @if (fix.link) {
              <mat-icon [routerLink]="fix.link">launch</mat-icon>
            }
          </li>
        }
      </ol>
    </div>
  }
  @if (details.publicSessions.new) {
    <div class="new">
      <h4>
        <mat-icon>star_rate</mat-icon>
        Nowości
      </h4>
      <ol>
        @for (fix of details.publicSessions.new; track fix) {
          <li>
            {{ fix.label }}
            @if (fix.link) {
              <mat-icon [routerLink]="fix.link">launch</mat-icon>
            }
          </li>
        }
      </ol>
    </div>
  }
  @if (details.general) {
    <h3>Zmiany ogólne</h3>
    @if (details.general.fix) {
      <div>
        <h4>
          <mat-icon>thumb_up</mat-icon>
          Poprawki
        </h4>
        <ol>
          @for (fix of details.general.fix; track fix) {
            <li>
              {{ fix.label }}
              @if (fix.link) {
                <mat-icon [routerLink]="fix.link">launch</mat-icon>
              }
            </li>
          }
        </ol>
      </div>
    }
    @if (details.general.new) {
      <div class="new">
        <h4>
          <mat-icon>star_rate</mat-icon>
          Nowości
        </h4>
        <ol>
          @for (fix of details.general.new; track fix) {
            <li>
              {{ fix.label }}
              @if (fix.link) {
                <mat-icon [routerLink]="fix.link">launch</mat-icon>
              }
            </li>
          }
        </ol>
      </div>
    }
  }
}
